export default {
  logIn: {
    uri: '/oauth/token',
    method: 'POST',
    loading: true,
    subdomain: false,
    needsVerified: false
  },
  logOut: {
    uri: 'oauth/tokens/%token%',
    method: 'DELETE',
    loading: true,
    subdomain: false,
    needsVerified: false
  },
  getAuthAccount: {
    uri: 'account',
    method: 'GET',
    loading: true,
    subdomain: true,
    needsVerified: false
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/endpoints/auth.js